import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import taxiOfficerListingUserPermissionDefinition from "./taxi-officer-listing-user-permission";

const useTaxiOfficerListingUserPermissions = () => {
  return useUserPermissions(taxiOfficerListingUserPermissionDefinition);
};

export default useTaxiOfficerListingUserPermissions;
